import { render, staticRenderFns } from "./MoleculeContentEditorModalAllowedUrl.vue?vue&type=template&id=565b6d9f"
import script from "./MoleculeContentEditorModalAllowedUrl.vue?vue&type=script&lang=js"
export * from "./MoleculeContentEditorModalAllowedUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports